export default __webpack_public_path__ + "media/images/react_icons/property/gated_building-f53e036f257e9909d30f596d2b847b1f.svg";